import api from "./api";

// Create a new note
const createNote = (data) => {
  return api.post("/api/customer-note/create", data);
};

// The person's unread chat messages: { total, wos: { [woId]: count } }.
const getUnread = () => {
  return api.get("/api/customer-note/unread");
};

// They've read this work order's chat.
const markRead = (woId) => {
  return api.post("/api/customer-note/read", { woId });
};

const NoteService = {
  createNote,
  getUnread,
  markRead,
};

export default NoteService;
